import { TDataEntry } from '../types/TDataEntry'

// simply removes the surrounding 'data' and returns the objects
const normalizeDataEntries = <T> (entries ?: TDataEntry<T>[]) : T[] => entries?.filter((entry) => !!entry.data).map((entry) => entry.data as T) || []
export default normalizeDataEntries
